import React, { FunctionComponent } from 'react';
import Router from 'next/router';
import { Button } from 'react-bootstrap';

import Block from '@views/components/block/Block';
import { Row, Col, Card } from 'react-bootstrap';
import { ACTION } from '../../intl';
import { ErrorText } from '@views/modules/quotation/quotation-form/styled';

export interface Props {
  totalNotEnough: boolean;
  quantity: number;
  totalText: string;
  discount?: number;
  discountText?: string;
  grandTotalText?: string;
  disabled: boolean;
  onSubmit: () => void;
}

export const Action: FunctionComponent<Props> = ({
  quantity,
  totalText,
  discount = 0,
  discountText = '',
  grandTotalText = '',
  disabled,
  totalNotEnough,
  onSubmit,
}) => {
  return (
    <Block isSection>
      <Row className="justify-content-end">
        <Col md={7} lg={5} xl={4}>
          <Card className="card--summary">
            <Card.Body>
              <div className="card__info">
                <span>
                  {String.prototype.replace.call(
                    ACTION.TOTAL,
                    '{amount}',
                    quantity
                  )}
                </span>
                <span className="card__price">{totalText}</span>
              </div>
              <div className="card__info">
                <span>
                  {String.prototype.replace.call(
                    ACTION.DISCOUNT,
                    '{discount}',
                    discount
                  )}
                </span>
                <span className="card__price">{discountText}</span>
              </div>
              <div className="card__info">
                <span style={{ fontWeight: 'bold' }}>{ACTION.GRAND_TOTAL}</span>
                <span className="card__price">{grandTotalText}</span>
              </div>
              <Button
                variant="primary"
                size="lg"
                className="card__link"
                disabled={disabled}
                onClick={onSubmit}
              >
                {ACTION.BUY}
              </Button>
              {!!totalNotEnough && <ErrorText>Quý khách vui lòng đặt đơn hàng online từ 1.000.000đ</ErrorText>}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Block>
  );
};

export default Action;
